import React from 'react'

const SocialIcon = () => {
  return (
    <footer className=" text-pureWhite  pb-6 px-4 font-sans tracking-wide">
      <div className="text-center">
        {/* <h6 className="text-lg text-gray-300">Stay connected with us:</h6> */}
        <ul className="flex flex-wrap  gap-x-8 gap-4 mt-8 ">
          <li>
            <a href="https://www.Facebook.com/Mysticalfragrance">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="fill-blue-600 h-8 w-8"
                viewBox="0 0 49.652 49.652"
              >
                <path
                  d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zM31 25.7h-4.039v14.396h-5.985V25.7h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939h-3.219c-.524 0-1.269.262-1.269 1.386v2.99h4.56z"
                  data-original="#000000"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@mysticalfragranc">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                className="w-8 h-8"
                fill="none"
              >
                <rect width="32" height="32" fill="#fff" rx="16" />
                <path
                  fill="#000"
                  d="M21.5 9.85a4.14 4.14 0 0 1-2.1-.56 4.3 4.3 0 0 1-1.58-1.56V19a4.92 4.92 0 0 1-1.5 3.5 4.77 4.77 0 0 1-3.38 1.45 4.78 4.78 0 0 1-3.38-1.4 4.74 4.74 0 0 1 0-6.76 4.78 4.78 0 0 1 3.4-1.4c.2 0 .4 0 .6.05V17a2.5 2.5 0 0 0-.6-.07 2.8 2.8 0 0 0-2 4.8 2.8 2.8 0 0 0 2 .85 2.8 2.8 0 0 0 2-.85 2.88 2.88 0 0 0 .88-2V7.5h2.25a4.16 4.16 0 0 0 1.46 2 4.2 4.2 0 0 0 2.29.64v2.22Z"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/mysticalfragranc">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8"
                viewBox="0 0 152 152"
              >
                <linearGradient
                  id="a"
                  x1="22.26"
                  x2="129.74"
                  y1="22.26"
                  y2="129.74"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset={0} stopColor="#fae100" />
                  <stop offset=".15" stopColor="#fcb720" />
                  <stop offset=".3" stopColor="#ff7950" />
                  <stop offset=".5" stopColor="#ff1c74" />
                  <stop offset={1} stopColor="#6c1cd1" />
                </linearGradient>
                <g data-name="Layer 2">
                  <g data-name="03.Instagram">
                    <rect
                      width={152}
                      height={152}
                      fill="url(#a)"
                      data-original="url(#a)"
                      rx={76}
                    />
                    <g fill="#fff">
                      <path
                        fill="#ffffff10"
                        d="M133.2 26c-11.08 20.34-26.75 41.32-46.33 60.9S46.31 122.12 26 133.2q-1.91-1.66-3.71-3.46A76 76 0 1 1 129.74 22.26q1.8 1.8 3.46 3.74z"
                        data-original="#ffffff10"
                      />
                      <path
                        d="M94 36H58a22 22 0 0 0-22 22v36a22 22 0 0 0 22 22h36a22 22 0 0 0 22-22V58a22 22 0 0 0-22-22zm15 54.84A18.16 18.16 0 0 1 90.84 109H61.16A18.16 18.16 0 0 1 43 90.84V61.16A18.16 18.16 0 0 1 61.16 43h29.68A18.16 18.16 0 0 1 109 61.16z"
                        data-original="#ffffff"
                      />
                      <path
                        d="m90.59 61.56-.19-.19-.16-.16A20.16 20.16 0 0 0 76 55.33 20.52 20.52 0 0 0 55.62 76a20.75 20.75 0 0 0 6 14.61 20.19 20.19 0 0 0 14.42 6 20.73 20.73 0 0 0 14.55-35.05zM76 89.56A13.56 13.56 0 1 1 89.37 76 13.46 13.46 0 0 1 76 89.56zm26.43-35.18a4.88 4.88 0 0 1-4.85 4.92 4.81 4.81 0 0 1-3.42-1.43 4.93 4.93 0 0 1 3.43-8.39 4.82 4.82 0 0 1 3.09 1.12l.1.1a3.05 3.05 0 0 1 .44.44l.11.12a4.92 4.92 0 0 1 1.1 3.12z"
                        data-original="#ffffff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.threads.net/@mysticalfragranc">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8"
                viewBox="0 0 512 512"
              >

                <path
                  d="M105 0h302c57.75 0 105 47.25 105 105v302c0 57.75-47.25 105-105 105H105C47.25 512 0 464.75 0 407V105C0 47.25 47.25 0 105 0z"
                  fill="#000000"
                />


                <path
                  fill="#fff"
                  d="M337.36 243.58c-1.46-.7-2.95-1.38-4.46-2.02-2.62-48.36-29.04-76.05-73.41-76.33-25.6-.17-48.52 10.27-62.8 31.94l24.4 16.74c10.15-15.4 26.08-18.68 37.81-18.68h.4c14.61.09 25.64 4.34 32.77 12.62 5.19 6.04 8.67 14.37 10.39 24.89-12.96-2.2-26.96-2.88-41.94-2.02-42.18 2.43-69.3 27.03-67.48 61.21.92 17.35 9.56 32.26 24.32 42.01 12.48 8.24 28.56 12.27 45.26 11.35 22.07-1.2 39.37-9.62 51.45-25.01 9.17-11.69 14.97-26.84 17.53-45.92 10.51 6.34 18.3 14.69 22.61 24.73 7.31 17.06 7.74 45.1-15.14 67.96-20.04 20.03-44.14 28.69-80.55 28.96-40.4-.3-70.95-13.26-90.81-38.51-18.6-23.64-28.21-57.79-28.57-101.5.36-43.71 9.97-77.86 28.57-101.5 19.86-25.25 50.41-38.21 90.81-38.51 40.68.3 71.76 13.32 92.39 38.69 10.11 12.44 17.73 28.09 22.76 46.33l28.59-7.63c-6.09-22.45-15.67-41.8-28.72-57.85-26.44-32.53-65.1-49.19-114.92-49.54h-.2c-49.72.35-87.96 17.08-113.64 49.73-22.86 29.05-34.65 69.48-35.04 120.16v.24c.39 50.68 12.18 91.11 35.04 120.16 25.68 32.65 63.92 49.39 113.64 49.73h.2c44.2-.31 75.36-11.88 101.03-37.53 33.58-33.55 32.57-75.6 21.5-101.42-7.94-18.51-23.08-33.55-43.79-43.48zm-76.32 71.76c-18.48 1.04-37.69-7.26-38.64-25.03-.7-13.18 9.38-27.89 39.78-29.64 3.48-.2 6.9-.3 10.25-.3 11.04 0 21.37 1.07 30.76 3.13-3.5 43.74-24.04 50.84-42.15 51.84z"
                />
              </svg>



            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@mysticalfragrance">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                fill="rgb(255 0 0)"
                className="bi h-8 w-8 bi-twitter"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12.2439 4C12.778 4.00294 14.1143 4.01586 15.5341 4.07273L16.0375 4.09468C17.467 4.16236 18.8953 4.27798 19.6037 4.4755C20.5486 4.74095 21.2913 5.5155 21.5423 6.49732C21.942 8.05641 21.992 11.0994 21.9982 11.8358L21.9991 11.9884L21.9991 11.9991C21.9991 11.9991 21.9991 12.0028 21.9991 12.0099L21.9982 12.1625C21.992 12.8989 21.942 15.9419 21.5423 17.501C21.2878 18.4864 20.5451 19.261 19.6037 19.5228C18.8953 19.7203 17.467 19.8359 16.0375 19.9036L15.5341 19.9255C14.1143 19.9824 12.778 19.9953 12.2439 19.9983L12.0095 19.9991L11.9991 19.9991C11.9991 19.9991 11.9956 19.9991 11.9887 19.9991L11.7545 19.9983C10.6241 19.9921 5.89772 19.941 4.39451 19.5228C3.4496 19.2573 2.70692 18.4828 2.45587 17.501C2.0562 15.9419 2.00624 12.8989 2 12.1625V11.8358C2.00624 11.0994 2.0562 8.05641 2.45587 6.49732C2.7104 5.51186 3.45308 4.73732 4.39451 4.4755C5.89772 4.05723 10.6241 4.00622 11.7545 4H12.2439ZM9.99911 8.49914V15.4991L15.9991 11.9991L9.99911 8.49914Z"
                ></path>
              </svg>
            </a>
          </li>
        </ul>

      </div>
    </footer>
  )
}

export default SocialIcon
